import React, { useEffect, useState } from 'react'
import Container from '../../ui/comp/Container'
import { useMutation, useQuery } from '@tanstack/react-query'
import { Axios } from '../../utils/Axios'
import Switch from 'react-switch'
import toast from 'react-hot-toast'
import Button from '../../ui/comp/Button'

function StoreSettings() {

    const [formData, setFormData] = useState({ cash_on_delivery: true, paystack: true })

    const { data } = useQuery({
        queryKey: ["store-settings"],
        queryFn: async () => {
            const res = await Axios.get('/store/store-settings')
            return res.data
        }
    })

    useEffect(() => {
        setFormData(data || { cash_on_delivery: true, paystack: true })
    }, [data])


    // Send Data

    const { mutate, isPending } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post('/store/store-settings', formData)
        },
        onError: (error) => {
            toast.error(error?.response?.data || error.message)
        },
        onSuccess: () => {
            toast.success("Successfully")
        }
    })

    const sendData = () => {
        mutate(formData)
    }


    return (
        <div className='w-full relative'>
            <Container title={"Store Settings"}>
                <div className="space-y-5 mt-8">
                    {/* Cash On Delivery */}
                    <div className="flex items-center gap-3">
                        <div className="w-full"> <p>Enable Cash On Delivery</p></div>
                        <div className="w-full">
                            <Switch
                                checked={formData?.cash_on_delivery}
                                onChange={() => setFormData({ ...formData, cash_on_delivery: !formData?.cash_on_delivery })}
                                checkedIcon={false}
                                uncheckedIcon={false}
                                onColor='#180787'
                                height={20}
                                handleDiameter={15}
                                width={38}
                            />
                        </div>
                    </div>

                    {/* Paystack */}

                    <div className="flex items-center gap-3">
                        <div className="w-full"> <p>Enable Paystack Payment</p></div>
                        <div className="w-full">
                            <Switch
                                checked={formData?.paystack}
                                onChange={() => setFormData({ ...formData, paystack: !formData?.paystack })}
                                checkedIcon={false}
                                uncheckedIcon={false}
                                onColor='#180787'
                                height={20}
                                handleDiameter={15}
                                width={38}
                            />
                        </div>
                    </div>
                </div>

                <div className="mt-8">
                    <Button loading={isPending} onClick={sendData}>Submit</Button>
                </div>
            </Container>
        </div>
    )
}

export default StoreSettings